var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivR" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "", disabled: _vm.btnBloquear },
                      on: {
                        click: function($event) {
                          return _vm.cerrarOperacion()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.esEdicion ? "Editar Zona" : "Ver Detalle Zona"
                        ) +
                        "\n        "
                    )
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _vm.esEdicion
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "btn-grabar",
                              attrs: {
                                depressed: "",
                                disabled:
                                  !_vm.validForm || _vm.btnBloquear
                                    ? true
                                    : false
                              },
                              on: {
                                click: function($event) {
                                  return _vm.grabarEdicion()
                                }
                              }
                            },
                            [_vm._v("Guardar Cambios")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c(
                "div",
                [
                  _c(
                    "v-card",
                    { attrs: { height: "55px", flat: "" } },
                    [
                      _c(
                        "v-bottom-nav",
                        {
                          attrs: {
                            active: _vm.bottomNav,
                            value: true,
                            absolute: "",
                            color: "transparent"
                          },
                          on: {
                            "update:active": function($event) {
                              _vm.bottomNav = $event
                            }
                          }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (_vm.dibujar.visible && _vm.esEdicion) ||
                                    (_vm.dibujarVerDetalle.visible &&
                                      !_vm.esEdicion),
                                  expression:
                                    "\n                (dibujar.visible && esEdicion) ||\n                  (dibujarVerDetalle.visible && !esEdicion)\n              "
                                }
                              ],
                              attrs: {
                                color: "primary",
                                flat: "",
                                value: _vm.dibujar.step
                              }
                            },
                            [
                              _c("span", [_vm._v("Dibujar")]),
                              _c("v-icon", [_vm._v("edit_location")])
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (_vm.informacionGeneral.visible &&
                                      _vm.esEdicion) ||
                                    (_vm.informacionGeneralVerDetalle.visible &&
                                      !_vm.esEdicion),
                                  expression:
                                    "\n                (informacionGeneral.visible && esEdicion) ||\n                  (informacionGeneralVerDetalle.visible && !esEdicion)\n              "
                                }
                              ],
                              attrs: {
                                color: "primary",
                                flat: "",
                                value: _vm.informacionGeneral.step
                              },
                              on: {
                                click: function($event) {
                                  return _vm.cierraMenu()
                                }
                              }
                            },
                            [
                              _c("span", [_vm._v("Información General")]),
                              _c("v-icon", [_vm._v("info")])
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (_vm.showAsocVehic &&
                                      _vm.AsociarVehiculos.visible &&
                                      _vm.esEdicion) ||
                                    (_vm.showAsocVehic &&
                                      _vm.AsociarVehiculosVerDetalle.visible &&
                                      !_vm.esEdicion),
                                  expression:
                                    "\n                (showAsocVehic && AsociarVehiculos.visible && esEdicion) ||\n                  (showAsocVehic &&\n                    AsociarVehiculosVerDetalle.visible &&\n                    !esEdicion)\n              "
                                }
                              ],
                              attrs: {
                                color: "primary",
                                flat: "",
                                value: _vm.AsociarVehiculos.step
                              },
                              on: {
                                click: function($event) {
                                  return _vm.cierraMenu()
                                }
                              }
                            },
                            [
                              _c("span", [_vm._v("Asociar Vehículos")]),
                              _c("v-icon", [_vm._v("directions_car")])
                            ],
                            1
                          ),
                          _vm.showConfAlerts
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    flat: "",
                                    value: "4"
                                  }
                                },
                                [
                                  _c("span", [_vm._v("Configurar Alertas")]),
                                  _c("v-icon", [_vm._v("report")])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.bottomNav == _vm.dibujar.step &&
                            ((_vm.dibujar.visible && _vm.esEdicion) ||
                              (_vm.dibujarVerDetalle.visible &&
                                !_vm.esEdicion)),
                          expression:
                            "\n            bottomNav == dibujar.step &&\n              ((dibujar.visible && esEdicion) ||\n                (dibujarVerDetalle.visible && !esEdicion))\n          "
                        }
                      ],
                      attrs: { align: "center" }
                    },
                    [
                      _c(
                        "v-alert",
                        {
                          attrs: {
                            value: _vm.showMessageDraw,
                            color: "warning",
                            icon: "priority_high",
                            outline: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n            No se puede modificar el dibujo de la geocerca porque ya se\n            encuentra asociada a vehículos.\n          "
                          )
                        ]
                      ),
                      _c(
                        "v-alert",
                        {
                          attrs: {
                            value: _vm.showMessageConfirmDraw,
                            color: "warning",
                            icon: "priority_high",
                            outline: ""
                          }
                        },
                        [
                          _vm._v(
                            "Se espera confirmación del sistema para poder modificar\n            dibujo."
                          )
                        ]
                      ),
                      _c("app-google-map", {
                        key: _vm.keyMap,
                        attrs: {
                          name: "zona-edit",
                          show: _vm.show,
                          enableControls: _vm.editDraw,
                          coordenadas: _vm.zona.formaJson,
                          geometria: _vm.zona.tipoGeometria,
                          tipozona: _vm.zona.tipoZonaId,
                          restrictDrawers: _vm.restrictDrawers,
                          module: "zonas"
                        },
                        on: {
                          enableContinueEmit: function($event) {
                            return _vm.enableContinue($event)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.bottomNav == _vm.informacionGeneral.step &&
                            ((_vm.informacionGeneral.visible &&
                              _vm.esEdicion) ||
                              (_vm.informacionGeneralVerDetalle.visible &&
                                !_vm.esEdicion)),
                          expression:
                            "\n            bottomNav == informacionGeneral.step &&\n              ((informacionGeneral.visible && esEdicion) ||\n                (informacionGeneralVerDetalle.visible && !esEdicion))\n          "
                        }
                      ],
                      staticClass: "cardnew",
                      attrs: { align: "center" }
                    },
                    [
                      _c("br"),
                      _c(
                        "v-flex",
                        { attrs: { md10: "" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "rounded-card" },
                            [
                              _c(
                                "v-form",
                                {
                                  ref: "form",
                                  staticClass: "col-md-12",
                                  attrs: { "lazy-validation": "" },
                                  model: {
                                    value: _vm.validForm,
                                    callback: function($$v) {
                                      _vm.validForm = $$v
                                    },
                                    expression: "validForm"
                                  }
                                },
                                [
                                  _c(
                                    "v-container",
                                    { attrs: { "grid-list-md": "" } },
                                    [
                                      _c(
                                        "div",
                                        { attrs: { align: "left" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { md12: "" } },
                                            [
                                              _c(
                                                "h2",
                                                {
                                                  staticClass: "h2_title",
                                                  staticStyle: {
                                                    "margin-top":
                                                      "12px!important"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Información General\n                      "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _c("v-divider"),
                                      _c("br"),
                                      _c(
                                        "v-layout",
                                        { attrs: { wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-select", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  "item-value": "id",
                                                  "item-text": "nombre",
                                                  items: _vm.TipoZona,
                                                  label: "Tipo de Zona",
                                                  "data-vv-name": "tipozona",
                                                  disabled: true,
                                                  "error-messages": _vm.errors.collect(
                                                    "tipozona"
                                                  ),
                                                  "no-data-text":
                                                    "Sin resultados",
                                                  required: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.editedItem.tipoZonaId,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "tipoZonaId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.tipoZonaId"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value:
                                                      "required|NombreUnicoEditar|max:80",
                                                    expression:
                                                      "'required|NombreUnicoEditar|max:80'"
                                                  }
                                                ],
                                                attrs: {
                                                  label: "Nombre",
                                                  counter: 80,
                                                  "data-vv-name": "vnombre",
                                                  disabled: !_vm.esEdicion,
                                                  type: "text",
                                                  "error-messages": _vm.errors.collect(
                                                    "vnombre"
                                                  ),
                                                  required: ""
                                                },
                                                model: {
                                                  value: _vm.editedItem.nombre,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "nombre",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.nombre"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "max:200",
                                                    expression: "'max:200'"
                                                  }
                                                ],
                                                attrs: {
                                                  label: "Descripción",
                                                  counter: 200,
                                                  "data-vv-name": "descripcion",
                                                  "error-messages": _vm.errors.collect(
                                                    "descripcion"
                                                  ),
                                                  disabled: !_vm.esEdicion,
                                                  type: "text"
                                                },
                                                model: {
                                                  value:
                                                    _vm.editedItem.descripcion,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "descripcion",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.descripcion"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required: false,
                                                      max: 200
                                                    },
                                                    expression:
                                                      "{ required: false, max: 200 }"
                                                  }
                                                ],
                                                attrs: {
                                                  label: "Dirección",
                                                  counter: 200,
                                                  "data-vv-name": "direccion",
                                                  disabled: !_vm.esEdicion,
                                                  "error-messages": _vm.errors.collect(
                                                    "direccion"
                                                  ),
                                                  type: "text"
                                                },
                                                model: {
                                                  value:
                                                    _vm.editedItem.direccion,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "direccion",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.direccion"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value:
                                                      "numeric|min_value:0|max_value:1440",
                                                    expression:
                                                      "'numeric|min_value:0|max_value:1440'"
                                                  }
                                                ],
                                                attrs: {
                                                  label:
                                                    "Tiempo de Estadia en minutos",
                                                  disabled: !_vm.esEdicion,
                                                  "error-messages": _vm.errors.collect(
                                                    "tiempoEstadia"
                                                  ),
                                                  "data-vv-name":
                                                    "tiempoEstadia",
                                                  type: "numeric"
                                                },
                                                model: {
                                                  value:
                                                    _vm.editedItem
                                                      .tiempoEstadia,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "tiempoEstadia",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.tiempoEstadia"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.showVelocidad,
                                                    expression: "showVelocidad"
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: _vm.showVelocidad
                                                      ? "numeric|velocidadMaxima"
                                                      : "",
                                                    expression:
                                                      "\n                          showVelocidad ? 'numeric|velocidadMaxima' : ''\n                        "
                                                  }
                                                ],
                                                attrs: {
                                                  label: "Velocidad Máxima",
                                                  "data-vv-name":
                                                    "velocidadMaxGeo",
                                                  disabled: !_vm.esEdicion,
                                                  "error-messages": _vm.errors.collect(
                                                    "velocidadMaxGeo"
                                                  ),
                                                  type: "text"
                                                },
                                                model: {
                                                  value:
                                                    _vm.editedItem
                                                      .velocidadMaxGeo,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "velocidadMaxGeo",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.velocidadMaxGeo"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-select", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  "item-value": "id",
                                                  "item-text": "nombre",
                                                  items: _vm.TipoLugar,
                                                  "data-vv-name": "tipolugar",
                                                  label: "Grupo de Zonas",
                                                  disabled: !_vm.esEdicion,
                                                  "error-messages": _vm.errors.collect(
                                                    "tipolugar"
                                                  ),
                                                  "no-data-text":
                                                    "Sin resultados",
                                                  required: ""
                                                },
                                                model: {
                                                  value: _vm.editedItem.grupoId,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "grupoId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.grupoId"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.bottomNav == _vm.AsociarVehiculos.step &&
                            ((_vm.showAsocVehic &&
                              _vm.AsociarVehiculos.visible &&
                              _vm.esEdicion) ||
                              (_vm.showAsocVehic &&
                                _vm.AsociarVehiculosVerDetalle.visible &&
                                !_vm.esEdicion)),
                          expression:
                            "\n            bottomNav == AsociarVehiculos.step &&\n              ((showAsocVehic && AsociarVehiculos.visible && esEdicion) ||\n                (showAsocVehic &&\n                  AsociarVehiculosVerDetalle.visible &&\n                  !esEdicion))\n          "
                        }
                      ],
                      staticClass: "cardnew",
                      attrs: { align: "center" }
                    },
                    [
                      _c("br"),
                      _c(
                        "v-flex",
                        { attrs: { md10: "" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "rounded-card" },
                            [
                              _c(
                                "v-container",
                                {
                                  attrs: {
                                    "grid-list-md": "",
                                    "text-xs-center": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "div",
                                        { attrs: { align: "left" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { md12: "" } },
                                            [
                                              _c(
                                                "h2",
                                                { staticClass: "h2_title" },
                                                [_vm._v("Asociar Vehículos")]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _c("v-divider"),
                                  _c("br"),
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { md6: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Buscar...",
                                              "prepend-icon": "lock_open",
                                              "append-icon": "search"
                                            },
                                            on: {
                                              input:
                                                _vm.onFilterTextBoxChangedVehiculoEditar
                                            },
                                            model: {
                                              value:
                                                _vm.buscarVehiculosZonasEditar,
                                              callback: function($$v) {
                                                _vm.buscarVehiculosZonasEditar = $$v
                                              },
                                              expression:
                                                "buscarVehiculosZonasEditar"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c("br"),
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { md12: "" } },
                                        [
                                          _c(
                                            "v-card",
                                            [
                                              _c("ag-grid-vue", {
                                                staticClass:
                                                  "ag-theme-material",
                                                staticStyle: {
                                                  width: "100%",
                                                  height: "380px",
                                                  "font-family":
                                                    "'Asap', sans-serif"
                                                },
                                                attrs: {
                                                  columnDefs:
                                                    _vm.columnDefsVehiculo,
                                                  rowData:
                                                    _vm.vehiculosRespaldo,
                                                  rowSelection: "multiple",
                                                  rowMultiSelectWithClick:
                                                    "false",
                                                  pagination: "true",
                                                  paginationPageSize: "10",
                                                  suppressRowClickSelection:
                                                    "true",
                                                  sideBar: _vm.sideBar,
                                                  localeText: _vm.localeText,
                                                  onGridReady: _vm.onGridReady,
                                                  postProcessPopup:
                                                    _vm.onClickCell,
                                                  suppressCopyRowsToClipboard:
                                                    "true",
                                                  getRowNodeId:
                                                    _vm.getRowNodeIdVehiculoEditar,
                                                  suppressCsvExport: true,
                                                  suppressExcelExport: true,
                                                  isExternalFilterPresent:
                                                    _vm.isExternalFilterPresentVehiculo,
                                                  doesExternalFilterPass:
                                                    _vm.doesExternalFilterPassVehiculo
                                                },
                                                on: {
                                                  "selection-changed":
                                                    _vm.onSelectedChangeVehiculoZonaEditar,
                                                  "row-selected": function(
                                                    $event
                                                  ) {
                                                    return _vm.onRowSelectedVehiculoZonaEditar(
                                                      $event
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.bottomNav == "4",
                          expression: "bottomNav == '4'"
                        }
                      ],
                      attrs: { align: "center" }
                    },
                    [
                      _c(
                        "v-container",
                        { attrs: { "grid-list-md": "", "text-xs-center": "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "" } },
                            [
                              _c(
                                "v-flex",
                                {
                                  attrs: { xs12: "", sm6: "", "offset-sm3": "" }
                                },
                                [
                                  _c(
                                    "v-card",
                                    [
                                      _c("v-card-title", [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "title font-weight-light"
                                          },
                                          [_vm._v("Configuración de Alertas")]
                                        )
                                      ]),
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-list",
                                            { attrs: { "two-line": "" } },
                                            [
                                              _c(
                                                "v-list-tile",
                                                [
                                                  _c(
                                                    "v-list-tile-content",
                                                    [
                                                      _c("v-list-tile-title", [
                                                        _c("strong", [
                                                          _vm._v(
                                                            "Tipo de Alerta"
                                                          )
                                                        ])
                                                      ])
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-list-tile-action",
                                                    [
                                                      _c("v-list-tile-title", [
                                                        _c("strong", [
                                                          _vm._v("Estado")
                                                        ])
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c("v-divider"),
                                              _c(
                                                "v-list-tile",
                                                [
                                                  _c(
                                                    "v-list-tile-content",
                                                    [
                                                      _c("v-list-tile-title", [
                                                        _vm._v("Sobreestadía")
                                                      ])
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-list-tile-action",
                                                    [
                                                      _c(
                                                        "v-list-tile-action-text",
                                                        [
                                                          _c("v-switch", {
                                                            attrs: {
                                                              label: _vm.switch1
                                                                ? "Activa"
                                                                : "Inactiva"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.switch1,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.switch1 = $$v
                                                              },
                                                              expression:
                                                                "switch1"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c("v-divider"),
                                              _c(
                                                "v-list-tile",
                                                [
                                                  _c(
                                                    "v-list-tile-content",
                                                    [
                                                      _c("v-list-tile-title", [
                                                        _vm._v("Detención")
                                                      ])
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-list-tile-action",
                                                    [
                                                      _c(
                                                        "v-list-tile-action-text",
                                                        [
                                                          _c("v-switch", {
                                                            attrs: {
                                                              label: _vm.switch2
                                                                ? "Activa"
                                                                : "Inactiva"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.switch2,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.switch2 = $$v
                                                              },
                                                              expression:
                                                                "switch2"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c("v-divider"),
                                              _c(
                                                "v-list-tile",
                                                [
                                                  _c(
                                                    "v-list-tile-content",
                                                    [
                                                      _c("v-list-tile-title", [
                                                        _vm._v("Entrada")
                                                      ])
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-list-tile-action",
                                                    [
                                                      _c(
                                                        "v-list-tile-action-text",
                                                        [
                                                          _c("v-switch", {
                                                            attrs: {
                                                              label: _vm.switch3
                                                                ? "Activa"
                                                                : "Inactiva"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.switch3,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.switch3 = $$v
                                                              },
                                                              expression:
                                                                "switch3"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c("v-divider"),
                                              _c(
                                                "v-list-tile",
                                                [
                                                  _c(
                                                    "v-list-tile-content",
                                                    [
                                                      _c("v-list-tile-title", [
                                                        _vm._v("Salida")
                                                      ])
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-list-tile-action",
                                                    [
                                                      _c(
                                                        "v-list-tile-action-text",
                                                        [
                                                          _c("v-switch", {
                                                            attrs: {
                                                              label: _vm.switch4
                                                                ? "Activa"
                                                                : "Inactiva"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.switch4,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.switch4 = $$v
                                                              },
                                                              expression:
                                                                "switch4"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c("v-divider"),
                                              _c(
                                                "v-list-tile",
                                                [
                                                  _c(
                                                    "v-list-tile-content",
                                                    [
                                                      _c("v-list-tile-title", [
                                                        _vm._v(
                                                          "Exceso Velocidad Sobre:"
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-list-tile-action",
                                                    [
                                                      _c(
                                                        "v-list-tile-action-text",
                                                        [
                                                          _c("v-switch", {
                                                            attrs: {
                                                              label: _vm.switch5
                                                                ? "Activa"
                                                                : "Inactiva"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.switch5,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.switch5 = $$v
                                                              },
                                                              expression:
                                                                "switch5"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c("v-divider")
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                padding: "inherit"
                                              },
                                              attrs: { align: "left" }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "font-weight-light",
                                                  staticStyle: {
                                                    "font-size": "16px",
                                                    padding: "inherit"
                                                  }
                                                },
                                                [_vm._v("Notificar a:")]
                                              )
                                            ]
                                          ),
                                          _c("v-select", {
                                            staticStyle: { padding: "inherit" },
                                            attrs: {
                                              items: _vm.correosNotify,
                                              "single-line": "",
                                              "hide-details": "",
                                              "no-data-text": "Sin resultados"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.editar.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.editar.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event, false)
          }
        }
      }),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacion,
          titulo: _vm.tituloConfirmacion,
          mensaje: _vm.$t("mensajes.crud.editar.mensaje"),
          textoBtnSi: _vm.$t("mensajes.crud.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      }),
      _c(
        "div",
        { staticClass: "text-xs-center" },
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": 400 },
              model: {
                value: _vm.dialogErrorWarning,
                callback: function($$v) {
                  _vm.dialogErrorWarning = $$v
                },
                expression: "dialogErrorWarning"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dark: "", color: "primary" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticStyle: {
                            "font-size": "17px",
                            "margin-left": "10px !important"
                          }
                        },
                        [_vm._v("Error al Editar Geocerca")]
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c("v-card-text", [
                    _vm._v(_vm._s(_vm.mensajeAsociarGeocercas))
                  ]),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "#526da5", small: "" },
                          on: {
                            click: function($event) {
                              return _vm.closeErrorWarningGuardar()
                            }
                          }
                        },
                        [
                          _c("span", { staticStyle: { color: "white" } }, [
                            _vm._v("Aceptar")
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }